import { render, staticRenderFns } from "./BaaCustomInputs.vue?vue&type=template&id=87dd2f66&scoped=true&"
import script from "./BaaCustomInputs.vue?vue&type=script&lang=js&"
export * from "./BaaCustomInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dd2f66",
  null
  
)

export default component.exports